import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import PriceNotice from 'checkout/CheckoutRoutes/PackageCheckout/components/PriceNotice';
import PriceChecker from 'checkout/components/PriceCheckerOld';
import { PRICE_CHANGE_DIRECTION } from 'checkout/store/constants/actualization';
import { PriceChangeDirectionPropTypes } from 'checkout/CheckoutRoutes/PackageCheckout/proptypes/actualization';

const baseCls = 'checkout-price-changed';

const SidebarPrice = ({
  className,
  showPriceChanged,
  isRegularFlight,
  children,
  priceChangeDirectionType,
  hotelLink,
  isMobile,
}) => (
  <div
    className={classNames(className, {
      [baseCls]: showPriceChanged,
      [`${baseCls}_red`]:
        showPriceChanged &&
        isRegularFlight &&
        priceChangeDirectionType === PRICE_CHANGE_DIRECTION.UP,
    })}
  >
    {isMobile && children}
    {showPriceChanged ? (
      <PriceNotice
        isRegularFlight={isRegularFlight}
        priceChangeDirectionType={priceChangeDirectionType}
        hotelLink={hotelLink}
      />
    ) : (
      <PriceChecker />
    )}
    {!isMobile && children}
  </div>
);

SidebarPrice.defaultProps = {
  isRegularFlight: null,
  className: null,
  children: null,
};

SidebarPrice.propTypes = {
  className: PropTypes.string,
  showPriceChanged: PropTypes.bool.isRequired,
  isRegularFlight: PropTypes.bool,
  children: PropTypes.node,
  priceChangeDirectionType: PriceChangeDirectionPropTypes.isRequired,
  hotelLink: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default SidebarPrice;
